<template>
  <div class="container">
    <div class="login-container">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="left">
        <p class="title">
          {{ $t('login.title') }}
        </p>
        <el-form-item prop="username">
          <el-input
            v-model.trim="loginForm.username"
            :placeholder="$t('login.username')"
            name="username"
            type="text"
            autocomplete="on"
            clearable
            tabindex="1"
            @keyup.enter.native="enterUserName"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            ref="passwordInput"
            v-model="loginForm.password"
            type="password"
            :placeholder="$t('login.password')"
            name="password"
            auto-complete="on"
            @keyup.enter.native="handleLogin"
            clearable
            tabindex="2"
          />
        </el-form-item>
        <el-button :loading="loading" type="primary" class="submit_btn"
                   @click.native.prevent="handleLogin">
          {{ $t('login.logIn') }}
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { userLogin, userInfoGet } from '@/api/user';
import { isValueEmpty, isMobileOrPc } from '@/utils';

export default {
  name: 'Login',
  data() {
    const validateUsername = (rule, value, callback) => {
      if (isValueEmpty(value)) {
        callback(new Error(this.$t('login.pleaseEnterCorrectName')));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('login.pleaseEnterCorrectPwd')));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: '',
        password: '',
      },
      loginRules: {
        username: [{
          required: true,
          trigger: 'blur',
          validator: validateUsername,
        }],
        password: [{
          required: true,
          trigger: 'blur',
          validator: validatePassword,
        }],
      },
      loading: false,
      redirect: undefined,
    };
  },
  watch: {
    $route: {
      handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  methods: {
    async enterUserName() {
      const {
        username,
        password,
      } = this.loginForm;
      if (username && password) {
        this.login();
      } else {
        this.$refs.passwordInput.focus();
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.login();
        } else {
          console.log('error submit!!');
        }
      });
    },
    async login() {
      const {
        username,
        password,
      } = this.loginForm;
      this.loading = true;
      try {
        const res = await userLogin({
          username: username.trim(),
          password,
          forceOperate: false,
        });
        this.toNextPage(res.data);
      } catch ({ data, status, hideNormalError }) {
        const isHaveOtherUserLogin = status === 400 && data && data.length > 0 && data[0].errCode === 'LoginPOST_2';
        if (isHaveOtherUserLogin) {
          hideNormalError();
          this.$confirm(this.$t('login.exitTheAccountAndLoggedIn'), this.$t('remindInfo.warning'), {
            confirmButtonText: this.$t('remindInfo.confirm'),
            cancelButtonText: this.$t('remindInfo.cancel'),
            type: 'warning',
          }).then(async () => {
            this.userLoginForceOperate();
          }).catch(() => {
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      }
    },
    async userLoginForceOperate() {
      const {
        username,
        password,
      } = this.loginForm;
      try {
        const res = await userLogin({
          username: username.trim(),
          password,
          forceOperate: true,
        });
        this.toNextPage(res.data);
      } catch (e) {
        this.loading = false;
      } finally {
        // do nothing.
      }
    },
    async toNextPage(data) {
      try {
        const { token } = data;
        this.$store.commit('user/setToken', token);
        const infoRes = await userInfoGet();
        this.$message({
          type: 'success',
          message: this.$t('login.loginSuccess'),
        });
        const infoData = infoRes.data;
        this.$store.commit('user/saveUserInfo', infoData);
        if (isMobileOrPc()) {
          this.$router.replace({
            path: this.redirect || '/app',
          });
        } else {
          this.$router.replace({
            path: this.redirect || '/',
          });
        }
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .container {
    min-height: 100%;
    width: 100%;
    background: url("../assets/login_bg.png") center center no-repeat;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
    .login-container {
      position: relative;
      width: 300px;
      max-width: 100%;
      padding: 30px;
      margin: auto;
      overflow: hidden;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 4px;
    }
  }
  .title {
    font-size: 24px;
    color: white;
    text-align: center;
    margin-bottom: 20px;
  }
  .submit_btn {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  @media only screen and (max-width: 470px) {
    .container {
      .login-container {
        width: 80%;
      }
    }
  }
</style>
